import { IconProps } from '@tamagui/helpers-icon';
import { Trash2 } from '@tamagui/lucide-icons';
import { Pressable, PressableProps } from '@unistocks/components/basic/pressable';
import { withConfirm } from '@unistocks/components/confirm/with-confirm';
import { forwardRef, memo } from 'react';
import { TamaguiElement } from 'tamagui';

export type DeleteButtonProps = IconProps & Pick<PressableProps, 'onPress' | 'disabled'>;

export const DeleteButton = memo(
  forwardRef<TamaguiElement, IconProps>(({ onPress, disabled, ...iconProps }, ref) => {
    return (
      <Pressable
        ref={ref}
        withFeedback
        withScale
        hitSlop={12}
        disabled={disabled}
        onPress={onPress}
      >
        <Trash2 size={'$2'} color={'$danger'} {...iconProps} />
      </Pressable>
    );
  })
);

DeleteButton.displayName = 'DeleteButton';

export const ConfirmDelete = withConfirm(DeleteButton);
